import React, { useState, useEffect, FC, useMemo } from 'react';
import './user-table.scss';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import ShopTableRow from '../user-table-row/user-table-row';
import UserTableRow from '../user-table-row/user-table-row';
import { useSelector } from 'react-redux';
export enum UserStatus{
    ACTIVE = 'Active',
    NOT_ACTIVE = 'Not active'
}
export enum UserPosition{
    MANAGER = 'Manager',
    EMPLOYEE = 'Employee'
}
export enum UserPermissions {
    EMPLOYEE = 'Employee',
    MANAGER = 'Manager',
    SUPER_MANAGER = 'Super manager',
    QOLAIG = 'Qolaig'
}

const UserTable = (props) => {
    const [search, setSearch] = useState('');
    const users = useSelector((state: any) => state.user.users)
    const [checkedStocks, setCheckedStocks] = useState([]);
    
    const filteredUsers = useMemo(() => {
        return users.filter(user => user.name.toLowerCase().includes(search.toLowerCase()));
    }, [users, search]);

    const allChecked = checkedStocks.length === filteredUsers.length && filteredUsers.length;
    const setAllChecked = (checked: boolean) => {
        if(checked)
            setCheckedStocks(filteredUsers.map(stock => stock.id));
        else
            setCheckedStocks([]);
    }
    const setChecked = (checked: boolean, id: string) => {
        if(checked)
            setCheckedStocks([...checkedStocks, id]);
        else
            setCheckedStocks(checkedStocks.filter(stockId => stockId !== id));
    }
    return (
        <div className="user-table">
            <div className="user-table__upper">
                <span>Edit columns</span>
                <div className="user-table__upper__controls">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search"> </InputIcon>
                        <InputText placeholder="Search..." className="user-table__upper__controls__filter-button" onChange={(e)=>setSearch(e.target.value)} />
                    </IconField>
                    {/* <Button onClick={() => console.log('PREVIOUS')} icon="pi pi-filter" label={'Filters'} className="user-table__upper__controls__filter-button" /> */}
                    <Button onClick={() => props.setIsPopupOpen(true)} icon="pi pi-plus" iconPos='left' label={'Add user'} className="user-table__upper__controls__add-button" />
                </div>
           </div>
            <div className="user-table__table">
                <div className="user-table__table__header">
                    <Checkbox onChange={e => setAllChecked(e.checked)} checked={allChecked}></Checkbox>
                    <div>Users</div>
                    <div>Status</div>
                    <div>Shops</div>
                    <div>Permissions</div>
                </div>
                <div className="user-table__table__body">
                {filteredUsers.map((user) => (
                    <UserTableRow key={user.user_id} {...user} checked={checkedStocks.includes(user.user_id)} setChecked={(checked, id)=>setChecked(checked, id)} setUserToEdit={props.setUserToEdit} setWordToConfirm={props.setWordToConfirm} setUserIdToDelete={props.setUserIdToDelete}/>
                ))}
                </div>
            </div>

        </div>
    );
}
         
export default UserTable;